module.exports = __webpack_public_path__ + "static/media/22.325c0581.mp3";